export default __webpack_public_path__ + "static/assets/11ae57b4c1d38550b370ba112c2e376a.png";